import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class PaginatorI18nService extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.updateTranslations();
    translate.onLangChange.subscribe(() => this.updateTranslations());
  }

  private updateTranslations(): void {
    this.itemsPerPageLabel = this.translate.instant('table.itemsPerPage');
    this.nextPageLabel = this.translate.instant('table.nextPage');
    this.previousPageLabel = this.translate.instant('table.previousPage');
    this.firstPageLabel = this.translate.instant('table.firstPage');
    this.lastPageLabel = this.translate.instant('table.lastPage');
    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('table.rangeEmpty', { length });
    }
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return this.translate.instant('table.range', { endIndex, length, startIndex: startIndex + 1 });
  };
}
